import { ajax } from "../../app/core/ajax";
import { deletePopUp } from "../controls/deletePopUp";
import { alert } from "../core/alert";
import { errorAlert } from "../core/errorAlert";
import { errorCode } from "../core/errorHandling";
import { getErrorCode } from "../core/getErrorCode";
import { ll, LocalizedLanguage } from "../core/ll";
import { emptyFn } from "../core/util";
import { searchTypes } from "../data/searchTypes";
import { deleteOrderLine } from "./deleteOrderLine";

function showErrorMessage(e: any): void {
    let code = getErrorCode(e);
    if (!code) {
        return;
    }

    let header, message;
    switch (code) {
        case errorCode.CannotDeleteTheObject:
            header = "DeleteFailed";
            message = "ObjectIsBeingReferenced";
            break;
        case errorCode.CannotDeleteOrderLineWithProcessedPayment:
            header = "CannotDeleteOrderLineDueToPaymentStatus";
            message = "ErrorCode2030";
            break;
        case errorCode.CannotDeleteOrderLineWithCancelledPayment:
            header = "CannotDeleteOrderLineDueToPaymentStatus";
            message = "ErrorCode2031";
            break;
        case errorCode.CannotDeleteOrderLineWithRejectedPayment:
            header = "CannotDeleteOrderLineDueToPaymentStatus";
            message = "ErrorCode2032";
            break;
        default:
            return;
    }

    alert({
        header: ll(header),
        message: ll(message),
        type: "danger"
    });
}

export function deleteEntity(args) {
    var id = args.id,
        entity = args.entity,
        friendlyEntityName = args.friendlyEntityName,
        success = args.success || emptyFn,
        error = args.error || emptyFn,
        errorMessage = args.errorMessage || null,
        actions = args.actions || null,
        deleteMessage = args.deleteMessage || null,
        deleteMessageParameter = args.deleteMessageParameter || null,
        urlPrefix = args.urlPrefix || "",
        beforeSend = args.beforeSend,
        deferred = $.Deferred(),
        checkDelete = (args.checkDelete == true),
        checkLast = args.checkLast,
        grid = args.grid;

    var entityLL = friendlyEntityName || entity;
    if (LocalizedLanguage[`Entity.${entityLL}`]) {
        entityLL = `Entity.${entityLL}`;
    }

    if (entity != "OrderLine") {
        deferred.done(function (e) {
            success(e);
            deletePopUpInstance.window.close();
        });
    }

    deferred.fail(function (e) {
        error(e);
        showErrorMessage(e);

        deletePopUpInstance.window.close();
    });

    var deletePopUpInstance,
        deleteMe = function () {
        deletePopUpInstance = deletePopUp({
            friendlyEntityName: entityLL,
            deleteMessage: deleteMessage,
            deleteMessageParameter: deleteMessageParameter,
            actions: actions,
            onDelete: function (e) {
                $(e.currentTarget).closest(".k-window").mask();

                ajax({
                    type: "DELETE",
                    url: `${urlPrefix}${entity}?id=${id}&checkDelete=${checkDelete}`,
                    errorHandled: true,
                    companyGuid: args.companyGuid,
                    beforeSend: beforeSend
                }).done(function (j) {
                    alert({
                        header: ll("DeleteSuccess"),
                        message: ll("DeleteSuccessMessage").format(ll(entityLL)),
                        type: "success"
                    });

                    deferred.resolve(j);
                }).fail(function (response) {
                    var message = errorMessage
                        ? errorMessage(response)
                        : null;

                    if (!message) {
                        message = ll("DeleteFailMessage").format(ll(entityLL));
                    }

                    var responseJSON = response.responseJSON;
                    if (responseJSON.Errors.General[0].ErrorCode == errorCode.CannotDeleteTheObject) {
                        var searchTypeArray = [];

                        $.each(response.responseJSON.Errors.General[0].Data, function (index, item) {
                            var searchOptions = function () {
                                var options = [];

                                $.each(item.PropertyName, function (i, property) {
                                    options.push({
                                        field: property,
                                        id: `${property}Search`,
                                        type: "TextBox",
                                        label: property,
                                        iconType: "list",
                                        iconId: `${property}SearchIcon`,
                                        iconClasses: "vam"
                                    });
                                });

                                return options;
                            };

                            searchTypeArray.push(searchTypes.generate({
                                entityType: item.EntityName,
                                url: item.QueryString,
                                searchOptions: searchOptions()
                            }));
                        });

                        // var popUp = z.controls.searchPopUp({
                        //     id: "DeleteConflict",
                        //     title: z.ll("DeleteConflict"),
                        //     types: searchTypes,
                        //     buttons: [
                        //         {
                        //             name: z.ll("Ok"),
                        //             clickEvent: function(e) {

                        //             }
                        //         }
                        //     ]
                        // });

                        // $.each(e.responseJSON.Errors.General[0].Data, function(index, item) {
                        //     $.each(item.PropertyName, function(i, property) {
                        //         z.controls.autoComplete({
                        //             id: property + "Search",
                        //             entityType: entity,
                        //             clearIfInvalid: false,
                        //             disableAutoCompleteConditional: true
                        //         });

                        //         $("#" + property + "SearchIcon").tie("click", function() {
                        //             z.controls.searchPopUp({
                        //                 id: property + "SearchPopUp",
                        //                 title: z.ll(property),
                        //                 types: [
                        //                     z.searchTypes.generate(entity)
                        //                 ]
                        //             });
                        //         });
                        //     });
                        // });

                        // popUp.get("#MyCallsGrid_filterDataButton").off().tie("click", function () {
                        //     /*z.bind({ container: "#MyCallsDetails", bind: ".bind-value", unbind: true, setDataToNull: true });
                        //     parent.selectedCall = null;

                        //     //refresh grid using current values
                        //     $("#MyCallsGrid").data("kendoGrid").dataSource.read();*/

                        // });
                    } else if (getErrorCode(response)) {
                        errorAlert({ response: response });
                    } else {
                        alert({
                            header: ll("DeleteFailed"),
                            message: message,
                            type: "danger"
                        });
                    }
                    deferred.reject(response);
                });
            },
            onCancel: function () {
                deferred.reject({ clickedNo: true });
            }
        });
    };

    if (checkLast && grid && grid.dataSource._total <= 1) {
        ajax({
            url: `${entity}?$inlinecount=allpages&$top=0`
        }).done(function (data) {
            if (data.d.__count > 1) {
                deleteMe();
            } else {
                alert({
                    header: ll("CannotRemoveLastOneHeader"),
                    message: ll("CannotRemoveLastOneMessage").format(friendlyEntityName || entity),
                    type: "warning"
                });
                deferred.reject(data);
            }
        }).fail(function (e) {
            deferred.reject(e);
        });
    } else if (entity == "OrderLine") {
        let orderLineId = args.id as number,
            deleteOrderLineProise = deleteOrderLine(orderLineId);

        deleteOrderLineProise.then(function () {
            deferred.done();
        });
    } else {
        deleteMe();
    }

    return deferred;
}

export function deleteEntityPortal(args) {
    var id = args.id,
        entity = args.entity,
        friendlyEntityName = args.friendlyEntityName,
        success = args.success || emptyFn,
        error = args.error || emptyFn,
        errorMessage = args.errorMessage || null,
        actions = args.actions || null,
        deleteMessage = args.deleteMessage || null,
        urlPrefix = args.urlPrefix || "",
        beforeSend = args.beforeSend,
        deferred = $.Deferred(),
        checkDelete = (args.checkDelete == true),
        checkLast = args.checkLast,
        grid = args.grid,
        deleteData = args.data,
        urlOverride = args.urlOverride || null;

    var entityLL = friendlyEntityName || entity;
    if (LocalizedLanguage[`Entity.${entityLL}`]) {
        entityLL = `Entity.${entityLL}`;
    }

    deferred.done(function (e) {
        success(e);
        deletePopUpInstance.window.close();
    });

    deferred.fail(function (e) {
        error(e);
        var code = getErrorCode(e);
        if (code == errorCode.CannotDeleteTheObject) {
            alert({
                header: ll("DeleteFailed"),
                message: ll("ObjectIsBeingReferenced"),
                type: "danger"
            });
        }
        deletePopUpInstance.window.close();
    });

    var deletePopUpInstance,
        deleteMe = function () {
        deletePopUpInstance = deletePopUp({
            friendlyEntityName: entityLL,
            deleteMessage: deleteMessage,
            actions: actions,
            onDelete: function (e) {
                $(e.currentTarget).closest(".k-window").mask();

                ajax({
                    type: "DELETE",
                    url: urlOverride || `${urlPrefix}${entity}`,
                    errorHandled: true,
                    beforeSend: beforeSend,
                    data: deleteData
                }).done(function (j) {
                    alert({
                        header: ll("DeleteSuccess"),
                        message: ll("DeleteSuccessMessage").format(ll(entityLL)),
                        type: "success"
                    });

                    deferred.resolve(j);
                }).fail(function (response) {
                    var message = errorMessage
                        ? errorMessage(response)
                        : null;

                    if (!message) {
                        message = ll("DeleteFailMessage").format(ll(entityLL));
                    }

                    var responseJSON = response.responseJSON;
                    if (responseJSON.Errors.General[0].ErrorCode == errorCode.CannotDeleteTheObject) {
                        var searchTypeArray = [];

                        $.each(response.responseJSON.Errors.General[0].Data, function (index, item) {
                            var searchOptions = function () {
                                var options = [];

                                $.each(item.PropertyName, function (i, property) {
                                    options.push({
                                        field: property,
                                        id: `${property}Search`,
                                        type: "TextBox",
                                        label: property,
                                        iconType: "list",
                                        iconId: `${property}SearchIcon`,
                                        iconClasses: "vam"
                                    });
                                });

                                return options;
                            };

                            searchTypeArray.push(searchTypes.generate({
                                entityType: item.EntityName,
                                url: item.QueryString,
                                searchOptions: searchOptions()
                            }));
                        });

                        // var popUp = z.controls.searchPopUp({
                        //     id: "DeleteConflict",
                        //     title: z.ll("DeleteConflict"),
                        //     types: searchTypes,
                        //     buttons: [
                        //         {
                        //             name: z.ll("Ok"),
                        //             clickEvent: function(e) {

                        //             }
                        //         }
                        //     ]
                        // });

                        // $.each(e.responseJSON.Errors.General[0].Data, function(index, item) {
                        //     $.each(item.PropertyName, function(i, property) {
                        //         z.controls.autoComplete({
                        //             id: property + "Search",
                        //             entityType: entity,
                        //             clearIfInvalid: false,
                        //             disableAutoCompleteConditional: true
                        //         });

                        //         $("#" + property + "SearchIcon").tie("click", function() {
                        //             z.controls.searchPopUp({
                        //                 id: property + "SearchPopUp",
                        //                 title: z.ll(property),
                        //                 types: [
                        //                     z.searchTypes.generate(entity)
                        //                 ]
                        //             });
                        //         });
                        //     });
                        // });

                        // popUp.get("#MyCallsGrid_filterDataButton").off().tie("click", function () {
                        //     /*z.bind({ container: "#MyCallsDetails", bind: ".bind-value", unbind: true, setDataToNull: true });
                        //     parent.selectedCall = null;

                        //     //refresh grid using current values
                        //     $("#MyCallsGrid").data("kendoGrid").dataSource.read();*/

                        // });

                    } else if (getErrorCode(response)) {
                        errorAlert({ response: response });
                    } else {
                        alert({
                            header: ll("DeleteFailed"),
                            message: message,
                            type: "danger"
                        });
                    }
                    deferred.reject(response);
                });
            },
            onCancel: function () {
                deferred.reject({ clickedNo: true });
            }
        });
    };

    if (checkLast && grid.dataSource._total <= 1) {
        ajax({
            url: `${entity}?$inlinecount=allpages&$top=0`
        }).done(function (data) {
            if (data.d.__count > 1) {
                deleteMe();
            } else {
                alert({
                    header: ll("CannotRemoveLastOneHeader"),
                    message: ll("CannotRemoveLastOneMessage").format(friendlyEntityName || entity),
                    type: "warning"
                });
                deferred.reject(data);
            }
        }).fail(function (e) {
            deferred.reject(e);
        });
    } else {
        deleteMe();
    }

    return deferred;
}
